<template>
    <div>
        <k-wms-leaflet-map
            v-bind="$props"
            ref="map"
            :showDefaultOverlayLayers="true"
            @click="$emit('click', $event)"
            @control-layers-ready="handleControlLayersReady"
            :legend="mapLegend"
            :fullscreen="true"
        >
            <template v-slot:extra_controls>
                <l-control
                    v-if="layersLoading"
                    position="bottomright"
                >
                    <i class="fa fa-spinner fa-spin" style="font-size: 30px;"></i> 
                </l-control>
            </template>

            <!-- PASS ALL SLOTS TO CHILD COMPONENT -->
            <template v-for="(index, name) in $slots" v-slot:[name]>
                <slot :name="name"/>
            </template>
            <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
                <slot :name="name" v-bind="data"></slot>
            </template>

        </k-wms-leaflet-map>
    </div>
</template>

<script>
import * as esri from 'esri-leaflet';

import { LControl } from 'vue2-leaflet';

import KWMSLeafletMap from './KWMSLeafletMap';
import baseprops from './KSimpleLeafletMap-props'
import { createCustomMapLegend, fetchArcGISLegend } from './utils/custom-map-legend';

import i18n from '@/i18n.js';

export default {
    setup() {
        return {
            i18n,
        }
    },
    components: {
        LControl,
        "k-wms-leaflet-map": KWMSLeafletMap,
    },
    props: {
        ...baseprops,
        arcGisLayers: {
            type: Array,
            required: false,
        },
        customLegendOptions: {
            type: Object,
            required: false,
        },
        arcGisLegendUrl: {
            type: String,
            required: false,
            default: null
        },
        arcGisLegendLayerId: {
            type: Number,
            required: false,
            default: null
        },
    },
    data: function() {
        return {
            esriLayers: [],
            layersLoading: false,
        }
    },
    methods: {
        addDynamicMapLayer: function(data) {
            const app = this;

            let layer = esri.dynamicMapLayer(data);
            if ( data.visible ) {
                layer.addTo(this.leafletMapObject);
                if ( data.zIndex ) {
                    layer.setZIndex(data.zIndex);
                }
                // layer.bringToFront();
                // layer.bringToBack();
            }
            this.esriLayers.push(layer);
            layer.name = data.name;

            layer.on("loading", function (event) {
                app.layersLoading = true;
            });

            layer.on("load", function (event) {
                app.layersLoading = false;
            });
        },
        addArcGisLayers: function() {
            if (this.arcGisLayers) {
                this.arcGisLayers.forEach(l => {
                    this.addDynamicMapLayer(l);
                });
            }
        },
        handleControlLayersReady: function() {
            this.esriLayers.forEach(layer => {
                this.$refs.map.addLayerToControl(layer, layer.name);
            });
        },
        fetchArcGisLegend: function() {
            if (this.arcGisLegendUrl && this.mapObject) {
                // Extract the base URL from the legend URL
                const baseUrl = this.arcGisLegendUrl.replace('/legend?f=pjson', '');
                
                fetchArcGISLegend({
                    url: baseUrl,
                    layerId: this.arcGisLegendLayerId,
                    position: "bottomleft",
                    onSuccess: (legend) => {
                        // Add the legend directly to the map
                        legend.addTo(this.mapObject);
                    },
                    onError: (error) => {
                        console.error("Failed to fetch ArcGIS legend:", error);
                    }
                });
            }
        },
        updateMapObject: function() {
            if (this.$refs.map) {
                this.mapObject = this.$refs.map.leafletMapObject;
                if (this.mapObject) {
                    this.addArcGisLayers();
                    this.fetchArcGisLegend();
                }
            }
        }
    },
    computed: {
        leafletMapObject: function(){
            return this.$refs.map.leafletMapObject;
        },
        mapLegend: function() {
            if (this.customLegendOptions) {
                return createCustomMapLegend(this.customLegendOptions);
            }
            return null;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.updateMapObject();
        });
    },
    watch: {
        // Watch for changes to the map reference
        '$refs.map': {
            handler(newMap) {
                if (newMap) {
                    this.updateMapObject();
                }
            },
            immediate: true
        }
    }
}
</script>

<style>
.arcis-map-legend-div {
    padding: 6px 8px;
    background: white;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 15px rgba(0,0,0,0.2);
    border-radius: 5px;
    line-height: 25px;
    color: #555;
    text-align: left;
    white-space: nowrap;
}
</style>
